import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  transform(value: any): string {
    // Converte o valor para número para garantir a manipulação correta
    const num = Number(value);

    // Verifica se o valor é um número válido
    if (isNaN(num)) return value; // Retorna o valor original se não for um número

    // Converte o número para um inteiro (removendo decimais) e formata com o padrão brasileiro
    return Math.floor(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
}
